/* eslint-disable-next-line import/prefer-default-export */
export const messageTypes = {
  GENERAL: "GENERAL",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
};
